import { buildURL } from "./buildURL.js";
const buildWidthSrcSet = (url, { widths, ...params }) => {
  return widths.map((width) => {
    return `${buildURL(url, { ...params, w: void 0, width })} ${width}w`;
  }).join(", ");
};
export {
  buildWidthSrcSet
};
//# sourceMappingURL=buildWidthSrcSet.js.map
